export const Env = {
  API_URL: process.env.REACT_APP_API_URL,
  ENABLE_DEVICE_UPLOAD: process.env.REACT_APP_ENABLE_DEVICE_UPLOAD === 'true',
  ALLOWED_FIRMWARE_EXTENSIONS: process.env.REACT_APP_ALLOWED_FIRMWARE_EXTENSIONS,
  ALLOWED_SIGNATURE_EXTENSIONS: process.env.REACT_APP_ALLOWED_SIGNATURE_EXTENSIONS,
}